// extracted by mini-css-extract-plugin
export default {"password_wrapper":"signature_password_password_wrapper__qSTTu","wrapper":"signature_password_wrapper__vTiCX","buttons":"signature_password_buttons__vLqjY"};